import util from '../util'

let controller = 'Limites'

export default Object.assign({}, util.GetCrud(controller, ['post', 'put', 'get', 'getall', 'delete']), {
  GetLimitesSugestao: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/GetLimitesSugestao', dto)
  }
})
